export default {
  TRIGGER_TYPE_DUE_DATE_BEFORE: 'before',
};



// WEBPACK FOOTER //
// ./src/variables/triggers.js